'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { IntlTFunc, useTranslations } from 'next-intl';
import { Fragment } from 'react';

import { styles } from './UiArticleHeaderBlog.styles';

const getNavItems = (t: IntlTFunc) => [
  {
    label: t('article.page.blog.articles.title'),
    path: '/about-skin/articles'
  },
  {
    label: t('article.page.blog.news.title'),
    path: '/about-skin/news'
  },
  {
    label: t('article.page.blog.videos.title'),
    path: '/about-skin/videos'
  }
];

export function UiArticleHeaderBlog() {
  const slots = styles();

  const t = useTranslations();

  const pathname = usePathname();

  const isActive = (path: string) => pathname.startsWith(path);

  const navItems = getNavItems(t);

  return (
    <div className={slots.container()}>
      <div className={slots.base()}>
        <h1 className={slots.title()}>
          <span className={slots.titleBlog()}>
            {t('article.page.blog.title')}
          </span>{' '}
          <span className={slots.aboutSkin()}>
            {t('article.page.blog.aboutSkin')}
          </span>
        </h1>
        <nav className={slots.nav()}>
          {navItems.map((item, index) => {
            const isLast = index === navItems.length - 1;

            return (
              <Fragment key={item.path}>
                <Link
                  href={item.path}
                  className={slots.navItem({ active: isActive(item.path) })}
                >
                  {item.label}
                </Link>
                {!isLast && <div> / </div>}
              </Fragment>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
